import { Session } from '@auth/core/types';

export const signOut = async (authority?: string, session?: Session) => {
	if (!session) return;

	const csrfTokePath = `/api/auth/csrf`;
	const logoutPath = '/api/auth/signout';

	const csrfTokenResponse = await fetch(csrfTokePath);
	const { csrfToken } = await csrfTokenResponse.json();
	const callbackUrl = window.location.href;

	await fetch(logoutPath, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'X-Auth-Return-Redirect': '1',
		},
		body: new URLSearchParams({
			csrfToken,
		}),
	});

	const federatedUrl = new URL(`${authority}/protocol/openid-connect/logout`);

	if (session.id_token)
		federatedUrl.searchParams.append('id_token_hint', session.id_token);

	federatedUrl.searchParams.append('client_id', 'tenant-frontend');
	federatedUrl.searchParams.append('post_logout_redirect_uri', callbackUrl);

	window.location.href = federatedUrl.href;
};
